import { createFileRoute, useNavigate } from "@tanstack/react-router";

import IllustrationAlert from "@repo/icons/colored/IllustrationAlert";
import ArrowRight from "@repo/icons/default/ArrowRight";

import { RoundedLayout } from "@/components/ui/layout/rounded-layout";
import { Button } from "@/components/ui/button/button";
import {
  EmptyStateV2Description,
  EmptyStateV2Root,
  EmptyStateV2Title,
} from "@/components/ui/empty-state/empty-state-v2";
import { Page } from "@/components/ui/layout/page/page";

import type { JSX } from "react";

const DismissedPage = (): JSX.Element => {
  const navigate = useNavigate();

  const handleContinue = (): void => {
    void navigate({ to: "/home" });
  };

  return (
    <RoundedLayout>
      <Page
        className="flex flex-col justify-between pb-0 px-6"
        showCustomerIoContainer={false}
      >
        <EmptyStateV2Root className="gap-4 py-4">
          <IllustrationAlert size={80} aria-hidden="true" />

          <div>
            <EmptyStateV2Title className="text-2xl font-medium">
              Você foi dispensado da reunião de boas vindas
            </EmptyStateV2Title>
            <EmptyStateV2Description className="text-md">
              Caso tenha alguma dúvida em relação ao nosso sistema ou precise de alguma
              orientação, entre em contato com o nosso time.
            </EmptyStateV2Description>
          </div>
        </EmptyStateV2Root>

        <div className="sticky bottom-0 flex flex-col gap-3 pt-4 pb-4 bg-white">
          <Button fullWidth color="secondary" onClick={handleContinue}>
            <div className="flex flex-row items-center justify-center gap-2">
              Continuar
              <ArrowRight size={24} aria-hidden="true" />
            </div>
          </Button>
        </div>
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute("/onboarding/welcome-meeting/dismissed")({
  component: DismissedPage,
});
